{
  "how_it_works": {
    "title": "How the game works",
    "sections": {
      "every_shot": {
        "title": "Every shot is played",
        "body": "You never swing. The game plays every round shot by shot on our server: the club, the aim, the wind, the lie, the bounce, the roll and the putt. Your part is the golfer's life: training, rest, the caddie, the kit and where to play."
      },
      "golfer": {
        "title": "Your golfer",
        "body": "Your golfer has 19 skills and 6 traits. Each shot uses the skills it needs: a wedge uses wedge play, a short putt uses short putting, a wet day uses bad-weather play."
      },
      "conditions": {
        "title": "The weather",
        "body": "Wind changes hour by hour, and it gusts. Rain, wet ground, cold, height above the sea and firm or soft ground all change how far the ball flies and how far it runs."
      },
      "ground": {
        "title": "The ground",
        "body": "The ball can lie in 12 different ways, from a perfect fairway to bare ground behind a tree. From the rough it can fly further than planned. In sand it can plug. On a wet day mud can stick to it."
      },
      "greens": {
        "title": "The greens",
        "body": "Every green has its own shape, speed and grain. Each day it plays a little differently, and the same for everyone who putts there that day."
      },
      "knowing": {
        "title": "What your golfer knows",
        "body": "Your golfer and caddie play on what they can judge. The true wind at the ball, the exact lie and the fine shape of each green stay on our server. Good judgement saves shots."
      },
      "mind": {
        "title": "Mind and body",
        "body": "Confidence, momentum, nerves, form and tiredness all move shots. Big moments cost shots, as they do in real golf, but never without limit."
      },
      "caddie_kit": {
        "title": "Caddie and kit",
        "body": "The caddie plans every hole: the route, the club and the aim. A better caddie plans better. How well the clubs fit, worn grooves and grips, the ball, shoes and waterproofs all count too."
      },
      "luck": {
        "title": "Luck, and how to check it",
        "body": "Luck is part of golf, and part of the game. Each round's luck is sealed before it starts. Check this round plays it again from the start, and a fair round says Matches."
      },
      "season": {
        "title": "Over a season",
        "body": "In one round, luck can beat anything. Over a season, how you prepare your golfer counts for more than luck. Your round report shows what helped and what hurt."
      },
      "coming": {
        "title": "Coming later",
        "body": "Club competitions, with a handicap that moves after each round. Live results while events are played."
      }
    }
  }
}
